import {Component, Inject, OnInit} from '@angular/core';
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import {HttpClient} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import swal from "sweetalert2";
import { VariablesGlobales } from '../services/globals';

@Component({
  selector: 'app-edit-experience',
  templateUrl: './edit-experience.component.html',
  styleUrls: ['./edit-experience.component.css']
})
export class EditExperienceComponent implements OnInit {
  expForm: FormGroup;
  emploiFonction: Fonction[] = [];
  experienceName: Experiences[] = [];
  secteurName: Secteur[] = [];


  public error: string;

  apikey: string;
  user: any;
  constructor(public param: VariablesGlobales, public dialogRef: MatDialogRef<EditExperienceComponent>, private fb: FormBuilder, private encdec: EncryptDecryptService, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.apikey = localStorage.getItem('apikey');
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
    this.getInfos()
    this.createForm();
  }


  getInfos() {
    this.http.get('https://api.sitederecrutement.com/Home/getinfos?apikey=' + this.apikey, {responseType: "text"}).subscribe(
      (result) => {
        if (result.includes('{Error :')) {
          let json = JSON.parse(result);
          this.error = json.Error;
        } else {
          const obj = JSON.parse(this.encdec.getDecrypt( result));
          this.experienceName = obj.experiences;
          this.emploiFonction = obj.fonctions;
          this.secteurName = obj.secteurs;
        }
      },
      (error) => {
        console.log(error);
      },
    )
  }

  createForm(){
    this.expForm = this.fb.group({
      deb: [this.data.profil_exp_debut, Validators.nullValidator],
      fin: [this.data.profil_exp_fin, Validators.nullValidator],
      intitule: [this.data.profil_exp_intitule, Validators.required],
      societe: [this.data.profil_exp_societe, Validators.required],
      fonction: [this.data.profil_exp_fonction, Validators.nullValidator],
      secteur: [this.data.profil_exp_secteur, Validators.nullValidator],
      expertise: [this.data.profil_exp_niveau, Validators.nullValidator],
      description: [this.data.profil_exp_descrip, Validators.nullValidator],
      competence_1: [this.data.profil_exp_comp1, Validators.nullValidator],
      competence_2: [this.data.profil_exp_comp2, Validators.nullValidator],
      competence_3: [this.data.profil_exp_comp3, Validators.nullValidator],
    });
  }

  setExperienceValue(): NewProfilExps{
    const expObj: NewProfilExps = {
      idprofil_exp: this.data.idprofil_exp,
      idprofil_cv: this.user.idcandidat,
      profil_exp_debut: this.expForm.get('deb').value,
      profil_exp_fin: this.expForm.get('fin').value,
      profil_exp_intitule: this.expForm.get('intitule').value,
      profil_exp_societe: this.expForm.get('societe').value,
      profil_exp_fonction: this.expForm.get('fonction').value,
      profil_exp_secteur: this.expForm.get('secteur').value,
      profil_exp_niveau: this.expForm.get('expertise').value,
      profil_exp_descrip: this.expForm.get('description').value,
      profil_exp_comp1: this.expForm.get('competence_1').value,
      profil_exp_comp2: this.expForm.get('competence_2').value,
      profil_exp_comp3: this.expForm.get('competence_3').value,
      profil_exp_andeb: "",
      profil_exp_duree: "",
      profil_exp_interim: "",
      profil_exp_lieu: "",
      profil_exp_moisdeb: "",
      profil_exp_moisfin: "",
      profil_exp_nbre: "",
      profil_exp_salaire: ""
    }
    return expObj;
  }

  onUpdate(){
    const expInfos = this.setExperienceValue();
    let data = this.encdec.getEncrypt( JSON.stringify(expInfos));
    const formData = new FormData();
    formData.append('datas', data);
    this.http.post('https://api.sitederecrutement.com/Home/UpdateExp?apikey='+this.apikey, formData, { responseType: "text" }).subscribe(
      (result) => {
        if (result.includes('{Error :')) {
          let json = JSON.parse(result);
          this.error = json.Error;
        }
        swal.fire({
          title: "Modifiée",
          text: "Votre expérience a bien été modifiée",
          buttonsStyling: false,
          customClass:{
            confirmButton: "btn btn-rose",
          },
          icon: "success",
          iconColor: 'd '
        });
        this.dialogRef.close();
      }
    )
  }

}

interface Fonction{
  idfonction: number;
  fonction: string;
}

interface Secteur{
  idsecteur_activite: number;
  secteur_activite: string;
  secteur_activite_anglais: string;
}

interface Experiences {
  idexperience: number;
  experience: string;
  experience_anglais: string;
}


interface NewProfilExps
{
  idprofil_exp: string;
  idprofil_cv: string;
  profil_exp_debut:  string;
  profil_exp_fin: string;
  profil_exp_intitule: string;
  profil_exp_descrip: string;
  profil_exp_lieu: string;
  profil_exp_nbre: string;
  profil_exp_societe: string;
  profil_exp_moisdeb: string;
  profil_exp_andeb: string;
  profil_exp_moisfin: string;
  profil_exp_salaire: string;
  profil_exp_interim: string;
  profil_exp_duree: string;
  profil_exp_fonction: string;
  profil_exp_niveau: string;
  profil_exp_secteur: string;
  profil_exp_comp1: string;
  profil_exp_comp2: string;
  profil_exp_comp3: string;
}
